import styled from '@emotion/styled';
import { css } from '@emotion/react';

import { breakpoints } from 'styles/basic';

interface DvdPhotoProps {
  sorce?: string | undefined;
}
interface VerticalProps {
  vertical?: boolean | undefined;
}

const Wrapper = styled.div`
  margin-bottom: 2rem;
`;

const DvdsWrapper = styled.ul`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: 0 -2rem;
  padding: 0;
  list-style: none;

  @media (min-width: ${breakpoints.laptop}) {
    justify-content: unset;
  }
`;

const DvdItem = styled.li<VerticalProps>`
  max-width: 31.2rem;
  padding: 2rem;

  ${(props) => props.vertical === true && css`
    width: 20.3rem;
  `};

  @media (min-width: ${breakpoints.portraitTablet}) {
    max-width: 34.2rem;

    ${(props) => props.vertical === true && css`
    width: 20.3rem;
  `};
  }
`;

const DvdName = styled.h1`
  display: flex;
  align-items: center;
  margin-top: 1rem;
  margin-bottom: 0;
  font-size: 1.6rem;
  color: ${(props) => props.theme.mainColors.trinary};
`;

const DvdDate = styled.div`
  font-size: 1.2rem;
  color: ${(props) => props.theme.colorGray.secondary};

  span {
    font-size: 1.2rem;
  }
`;

const DvdPhoto = styled.div<DvdPhotoProps & VerticalProps>`
  display: block;
  width: 27.3rem;
  height: 20.1rem;
  margin-bottom: 1rem;
  border: .1rem solid ${(props) => props.theme.color.gray};
  border-radius: .5rem;
  background: ${(props) => `url(${props.sorce}) center center no-repeat` || props.theme.color.lightGray};
  background-size: contain;

  ${(props) => props.vertical === true && css`
    width: 16.3rem;
    height: 22.2rem;
  `};

  @media (min-width: ${breakpoints.portraitTablet}) {
    width: 30.2rem;
    height: 22.2rem;

    ${(props) => props.vertical === true && css`
      width: 16.3rem;
      height: 22.2rem;
    `};
  }
`;

export {
  Wrapper,
  DvdsWrapper,
  DvdItem,
  DvdName,
  DvdDate,
  DvdPhoto
};
